var card_content_default = {
  "content": "Bfgpe",
  "textStart": "rSkur",
  "contentText": "SYUQQ",
  "subtitle": "N9IDl",
  "pricing": "_0lqVi",
  "titlePriceContainer": "shNOm",
  "textCenter": "aGc23",
  "textEnd": "WTq57",
  "titlePriceSideBySide": "vCZWY",
  "titlePriceStacked": "OZwfb",
  "title": "erHfu",
  "price": "eWmY1",
  "priceDiscounted": "MvseS",
  "priceOriginal": "LTf6W",
  "priceStrikethrough": "gwke0",
  "ribbon": "cAZPF",
  "button": "AhZOA",
  "button_disabled": "scAA0",
  "buttonText": "NYhHU",
  "framelessContent": "_6YAh7",
  "framelessImageTop": "_2JgJd",
  "framelessImageStart": "_8WM0O",
  "framelessImageEnd": "DL89T"
};
export {
  card_content_default as default
};
//# sourceMappingURL=card-content-scss.js.map
